import clipboard from "utils/clipboard/clipboard"
import InfoTooltip from "components/tooltip/info-tooltip"

export default function setListeners() {
  const els = document.querySelectorAll("[data-copy-to-clipboard]")

  ;[...els].forEach((el) => {
    const tooltip = new InfoTooltip("Copied successfully", "Into the clipboard")
    const target = el.dataset.copyTarget

    el.addEventListener("click", (event) => {
      event.preventDefault()
      clipboard(document.querySelector(target))
      tooltip.append(() => {
        tooltip.moveTo(el, () =>
          setTimeout(() => {
            tooltip.remove(() => 1)
          }, 1500),
        )
      })
    })
  })
}
